module.exports = __webpack_public_path__ + "img/report_bcimg.59bff854.png";